import React from "react";
import {Link} from "react-router-dom";

import "./../../css/secondary-header-menu.css";
import logo from "./../../images/w.png"

export class SecondaryHeaderComponent extends React.Component {

    render() {

        return (
            <section id="secondary-header-menu-component">
                <logo>
                    <img src={logo} alt="" />
                </logo>
                <Link to="/"><span className="home"><i className="fa fa-angle-left" aria-hidden="true"></i>&nbsp;<i className="fa fa-home" aria-hidden="true"></i></span></Link>
            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./src/widgets/Common/SecondaryHeaderComponent.js